import ModelInterface from './ModelInterface';

export default abstract class Model implements ModelInterface {
    readonly id: number;
    private dataProps: Set<string | number | symbol> = null;

    /**
     * @param data The object from which the data will be assigned.
     * @param modelProps Properties to assign that must be present in both the current model and the data object.
     */
    protected assignDataToProps<T extends this, D extends object>(data: D, modelProps: Array<keyof T & keyof D>) {
        if (!this.dataProps) {
            this.dataProps = new Set();
        }

        modelProps.forEach((prop) => {
            if (typeof data[prop] !== 'undefined') {
                this[prop as PropertyKey] = data[prop];
            }
            this.dataProps.add(prop);
        });
    }

    toJSON() {
        if (!this.dataProps) {
            return this;
        }

        const data = {};
        this.dataProps.forEach((prop) => {
            data[prop] = this[prop];
        });

        return data;
    }

    getNew<T extends this>(overwriteProps: Partial<T> = {}): T {
        return new (this.constructor as new (props: {}) => T)({ ...this, ...overwriteProps });
    }
}
